/**
 * CODIGOS para ejecutar scripts
 * -------------------
  0 "Ejecuta Script Registrado que devuelve filas";
  1 "Ejecuta Script Registrado que devuelve filas paginado";
  2 "Ejecuta un paquete insert";
  3 "Ejecuta un paquete update";
  4 "Ejecuta un paquete delete";
  5 "Ejecuta Script Registrado que no devuelve filas";
  6 "Ejecuta un Procedure de BD que devuelve filas";
  7 "Ejecuta un Procedure de BD que no devuelve filas";
  8 "Envio de Correos";
  9 "Devuelve los datos de una tabla especifica en base a una condicion";
 */
export default {
  EXECUTE: 0,
  EXECUTE_PAGINADO: 1,
  INSERT: 2,
  UPDATE: 3,
  DELETE: 4,
  EXECUTE_NO_RESPONSE: 5
};
